module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// /Users/nathan/dev/piggybk/aws-amplify/node_modules/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 362
// module chunks = 0 1